<template>
  <div id="app" class="min-h-screen bg-background">
    <router-view />
  </div>
</template>

<script setup lang="ts">
// Main app component with router view
</script>

<style>
#app {
  font-family: 'Inter', system-ui, sans-serif;
}
</style>
